import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";

import {
    Button,
    Card,
    CardActions,
    CircularProgress
} from '@mui/material';
import {
    Form,
    required,
    TextInput,
    useTranslate,
    useLogin,
    useNotify,
} from 'react-admin';

import Box from '@mui/material/Box';
import SelectTestUser from './SelectTestUser'; // import the component



const Login = () => {
    const [loading, setLoading] = useState(false);
    const [videoLoaded, setVideoLoaded] = useState(false);
    const translate = useTranslate();

    const notify = useNotify();
    const login = useLogin();

    // Delay video loading until page is interactive
    React.useEffect(() => {
        const timer = setTimeout(() => {
            setVideoLoaded(true);
        }, 100); // Small delay to let page render first
        return () => clearTimeout(timer);
    }, []);

    const handleSubmit = React.useCallback((auth) => {
        setLoading(true);
        login(
            auth,
            '/'
        ).catch((error) => {
            setLoading(false);
            notify(
                typeof error === 'string'
                    ? error
                    : typeof error === 'undefined' || !error.message
                    ? 'ra.auth.sign_in_error'
                    : error.message,
                {
                    type: 'warning',
                    messageArgs: {
                        _: typeof error === 'string'
                            ? error
                            : error && error.message
                            ? error.message
                            : undefined,
                    },
                }
            );
        });
    }, [login, notify]);

    return (
        <Form onSubmit={handleSubmit} noValidate>
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                alignItems: 'center',
                justifyContent: 'flex-start',
                position: 'relative',
                backgroundColor: '#1a1a1a', // Fallback background
            }}
        >
            {videoLoaded && (
                <video
                    autoPlay
                    loop
                    muted
                    preload="none"
                    style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        opacity: 0,
                        transition: 'opacity 0.5s ease-in-out',
                    }}
                    onLoadedData={(e) => {
                        e.target.style.opacity = 1;
                    }}
                    onError={(e) => {
                        e.target.style.display = 'none';
                    }}
                >
                    <source src="/videos/bghd_no_logo.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            )}
            <Card   sx={{
                        minWidth: 300,
                        marginTop: '6em',
                        position: 'relative', // Ensure the card is positioned above the video
                        zIndex: 1, // Make the card appear above the video
                    }}
                    
                    >


                    <Box
                        sx={{
                            margin: '1em',
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                             <Logo src="/images/logo_color.svg" />

                    </Box>
                    <Box
                        sx={{
                            marginTop: '1em',
                            display: 'flex',
                            justifyContent: 'center',
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        مرحبا بكم فى نظام رافد للنقل 
                    </Box>
                    <Box sx={{ padding: '0 1em 1em 1em' }}>


             {/* Select test user */}
  {            <Box sx={{ marginTop: '1em' }}>
                            <SelectTestUser />
                        </Box> }



                        <Box sx={{ marginTop: '1em' }}>
                            <TextInput
                                autoFocus
                                source="username"
                                label={translate('ra.auth.username')}
                                disabled={loading}
                                validate={required()}
                                fullWidth
                            />
                        </Box>
                        <Box sx={{ marginTop: '1em' }}>
                            <TextInput
                                source="password"
                                label={translate('ra.auth.password')}
                                type="password"
                                disabled={loading}
                                validate={required()}
                                fullWidth
                            />
                        </Box>
                    </Box>
                    <CardActions sx={{ padding: '0 1em 1em 1em' }}>
                        <Button
                            variant="contained"
                            type="submit"
                            color="primary"
                            disabled={loading}
                            fullWidth
                        >
                            {loading && (
                                <CircularProgress size={25} thickness={2} />
                            )}
                            {translate('ra.auth.sign_in')}
                        </Button>
                    </CardActions>
                </Card>
            </Box>
        </Form>
    );
};

const Logo = styled.img`
  width: 100px;
  margin: 30px;
`;

const VideoContainer = styled.div`
  overflow: hidden;
  height: 100vh;
  height: ${(props) => (props.small ? "50vh" : "100vh")};
`;

const VideoScrollDown = styled.div`
  position: absolute;
  bottom: 32px;
  left: 0;
  right: 0;
`;
const StyledVideo = styled.video`
  position: relative;
  object-fit: cover;
  height: ${(props) => (props.small ? "50vh" : "100vh")};

  width: 100vw;

  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;


Login.propTypes = {
    authProvider: PropTypes.func,
    previousRoute: PropTypes.string,
};

export default Login;
